export const logoNegative = [];
